export const logoNegative = [];
